(function() {
  if (window.AtlasChatbot) return;
  window.AtlasChatbot = true;

  var scriptSrc = document.currentScript.src;
  var scriptUrl = new URL(scriptSrc);
  var host = scriptUrl.origin;
  var presetTag = scriptUrl.searchParams.get('tag');

  var unreadCount = 0;

  // Create notification sound using Web Audio API
  var audioContext = null;
  function playNotificationSound() {
    try {
      if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
      }
      // Create a pleasant "ding" sound
      var oscillator = audioContext.createOscillator();
      var gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.frequency.setValueAtTime(830, audioContext.currentTime); // Higher pitch
      oscillator.type = 'sine';

      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);

      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.3);
    } catch (e) {
      // Audio not supported or blocked
    }
  }

  // Create launcher button
  var button = document.createElement('button');
  button.id = 'atlas-chatbot-launcher';
  button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:24px;height:24px;"><path stroke-linecap="round" stroke-linejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" /></svg>';
  button.style.cssText = 'position:fixed;bottom:16px;right:16px;width:56px;height:56px;border-radius:50%;background:#1F2937;color:white;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px rgba(0,0,0,0.15);z-index:9999;transition:transform 0.2s ease;';

  // Create unread badge
  var badge = document.createElement('span');
  badge.id = 'atlas-chatbot-badge';
  badge.style.cssText = 'position:absolute;top:-4px;right:-4px;min-width:20px;height:20px;border-radius:10px;background:#ef4444;color:white;font-size:12px;font-weight:600;display:none;align-items:center;justify-content:center;padding:0 6px;box-shadow:0 2px 4px rgba(0,0,0,0.2);animation:atlas-badge-pulse 2s infinite;';
  button.appendChild(badge);

  // Add badge pulse animation
  var style = document.createElement('style');
  style.textContent = '@keyframes atlas-badge-pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }';
  document.head.appendChild(style);

  function updateBadge() {
    if (unreadCount > 0) {
      badge.textContent = unreadCount > 9 ? '9+' : unreadCount;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  // Hover effect for button
  button.addEventListener('mouseenter', function() { button.style.transform = 'scale(1.05)'; });
  button.addEventListener('mouseleave', function() { button.style.transform = 'scale(1)'; });

  // Create popup container
  var popup = document.createElement('div');
  popup.id = 'atlas-chatbot-popup';

  // Responsive styles based on screen size
  function isMobile() {
    return window.innerWidth < 640;
  }

  function getPopupStyles(open) {
    var baseStyles = 'position:fixed;background:white;z-index:9998;overflow:hidden;display:flex;flex-direction:column;transition:opacity 0.2s ease,transform 0.2s ease;';
    var visibilityStyles = open
      ? 'opacity:1;transform:translateY(0) scale(1);pointer-events:auto;'
      : 'opacity:0;transform:translateY(20px) scale(0.95);pointer-events:none;';

    if (isMobile()) {
      // Full screen on mobile with safe area insets
      return baseStyles + 'top:0;left:0;right:0;bottom:0;width:100%;height:100%;border-radius:0;box-shadow:none;' + visibilityStyles;
    } else {
      // Desktop popup style
      return baseStyles + 'bottom:80px;right:16px;width:384px;height:600px;border-radius:16px;box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);' + visibilityStyles;
    }
  }

  popup.style.cssText = getPopupStyles(false);

  // Create header bar
  var header = document.createElement('div');
  header.id = 'atlas-chatbot-header';

  function getHeaderStyles() {
    var baseStyles = 'display:flex;align-items:center;justify-content:space-between;background:#1F2937;color:white;flex-shrink:0;';
    if (isMobile()) {
      // More padding on mobile, safe area for notch
      return baseStyles + 'padding:16px 16px;padding-top:max(16px, env(safe-area-inset-top));';
    }
    return baseStyles + 'padding:12px 16px;';
  }
  header.style.cssText = getHeaderStyles();

  var title = document.createElement('span');
  title.textContent = 'Chat';
  title.style.cssText = 'font-weight:600;font-size:16px;';

  var minimizeBtn = document.createElement('button');
  minimizeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:24px;height:24px;"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg>';
  minimizeBtn.style.cssText = 'background:none;border:none;color:white;cursor:pointer;padding:8px;display:flex;align-items:center;justify-content:center;border-radius:8px;transition:background 0.15s ease;-webkit-tap-highlight-color:transparent;';
  minimizeBtn.setAttribute('aria-label', 'Minimize chat');
  minimizeBtn.addEventListener('mouseenter', function() { minimizeBtn.style.background = 'rgba(255,255,255,0.2)'; });
  minimizeBtn.addEventListener('mouseleave', function() { minimizeBtn.style.background = 'none'; });

  header.appendChild(title);
  header.appendChild(minimizeBtn);
  popup.appendChild(header);

  // Create iframe container
  var iframeContainer = document.createElement('div');
  iframeContainer.style.cssText = 'flex:1;overflow:hidden;';

  // Create iframe
  var iframe = document.createElement('iframe');
  var iframeLoaded = false;
  // If there's a preset tag, defer loading until popup is opened to avoid creating chats on page load
  if (!presetTag) {
    iframe.src = host + '/chatbot/new';
    iframeLoaded = true;
  }
  iframe.style.cssText = 'width:100%;height:100%;border:none;';
  iframeContainer.appendChild(iframe);
  popup.appendChild(iframeContainer);

  var isOpen = false;

  function openPopup() {
    isOpen = true;
    popup.style.cssText = getPopupStyles(true);
    // Hide launcher button on mobile when chat is open
    if (isMobile()) {
      button.style.display = 'none';
    }
    // Load iframe with tag on first open (deferred to avoid creating chats on page load)
    if (!iframeLoaded) {
      var iframeSrc = host + '/chatbot/new';
      if (presetTag) {
        iframeSrc += '?tag=' + encodeURIComponent(presetTag);
      }
      iframe.src = iframeSrc;
      iframeLoaded = true;
    }
    // Clear unread count when opening
    unreadCount = 0;
    updateBadge();
  }

  function closePopup() {
    isOpen = false;
    popup.style.cssText = getPopupStyles(false);
    // Show launcher button again
    button.style.display = 'flex';
  }

  // Handle window resize to update popup styles
  window.addEventListener('resize', function() {
    header.style.cssText = getHeaderStyles();
    if (isOpen) {
      popup.style.cssText = getPopupStyles(true);
      button.style.display = isMobile() ? 'none' : 'flex';
    } else {
      popup.style.cssText = getPopupStyles(false);
    }
  });

  function togglePopup() {
    if (isOpen) {
      closePopup();
    } else {
      openPopup();
    }
  }

  // Listen for messages from the chatbot iframe
  window.addEventListener('message', function(event) {
    // Verify origin matches our chatbot host
    if (event.origin !== host) return;

    if (event.data && event.data.type === 'atlas-chatbot-new-message') {
      // Only increment unread count if popup is closed
      if (!isOpen) {
        unreadCount++;
        updateBadge();
        playNotificationSound();
      }
    }
  });

  button.addEventListener('click', togglePopup);
  minimizeBtn.addEventListener('click', togglePopup);

  document.body.appendChild(button);
  document.body.appendChild(popup);
})();
